// extracted by mini-css-extract-plugin
export default {"stockAvailability":"index_stockAvailability__GUjY-","title":"index_title__1ZA3L","storeSelector":"index_storeSelector__2WF6z","field":"index_field__1VM97"};